module.exports = __webpack_public_path__ + "static/media/bananas.5c6ec729.png";